/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import { useState } from "react"
import { FormName } from "./form/formContext"
import { ab } from "../theme"
import Button from "./button"

const Form = ({
  formName,
  heading,
  subHeading,
  buttonText,
  successHeading,
  successMessage,
  successBtnText,
  children,
}) => {
  const [submitted, setSubmitted] = useState(false)
  const serialize = form => {
    // Setup our serialized data
    let serialized = []

    // Loop through each field in the form
    for (let i = 0; i < form.elements.length; i++) {
      let field = form.elements[i]

      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (
        !field.name ||
        field.disabled ||
        field.type === "file" ||
        field.type === "reset" ||
        field.type === "submit" ||
        field.type === "button"
      )
        continue

      // If a multi-select, get all selections
      if (field.type === "select-multiple") {
        for (let n = 0; n < field.options.length; n++) {
          if (!field.options[n].selected) continue
          serialized.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(field.options[n].value)
          )
        }
      }

      // Convert field data to a query string
      else if (
        (field.type !== "checkbox" && field.type !== "radio") ||
        field.checked
      ) {
        serialized.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        )
      }
    }

    return serialized.join("&")
  }

  const handleSubmit = e => {
    e.preventDefault()

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: serialize(e.target),
    })
      .then(setSubmitted(true))
      .catch(error => alert(error))
  }

  const returnAfterSubmit = () => {
    setSubmitted(false)
  }

  if (!submitted) {
    return (
      <div
        sx={{
          variant: "spacingContainer",
          maxWidth: "1100px",
        }}
      >
        <div>
          <div
            sx={{
              fontSize: "34px",
              letterSpacing: 1,
            }}
          >
            {heading}
          </div>
          <div sx={{ marginBottom: 3 }}>{subHeading}</div>
        </div>
        <form
          name={formName}
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="form-name" value={formName} />
          <input type="hidden" name="bot-field" />

          <FormName.Provider value={formName}>{children}</FormName.Provider>
        </form>
      </div>
    )
  } else {
    return (
      <div
        sx={{
          variant: "spacingContainer",
        }}
      >
        <div
          sx={{
            maxWidth: ab({ lg: "50%" }),
          }}
        >
          <h1>{successHeading}</h1>
          {successMessage}
          <p>
            <Button onClick={returnAfterSubmit} buttonText={successBtnText} />
          </p>
        </div>
      </div>
    )
  }
}

Form.propTypes = {
  formName: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  successHeading: PropTypes.string.isRequired,
  successMessage: PropTypes.node.isRequired,
  successBtnText: PropTypes.string.isRequired,
  children: PropTypes.node,
}

Form.defaultProps = {
  buttonText: "Senden",
  successBtnText: "Weiter",
}

export default Form
